import { combineReducers, configureStore } from "@reduxjs/toolkit"

// import { authApi } from "features/auth/api"
import { authApi } from "store/api/authSlice"
import thunk from "redux-thunk"
import appReducer from "./appSlice"
// import authReducer from "./api/authSlice"
import parentApi from "./parentApi"

// import appReducer from "./appSlice"
const reducers = combineReducers({
  appState: appReducer,
  [appReducer.name]: appReducer.reducer,
  // [authReducer.reducerPath]: authReducer.reducerPath,
  [parentApi.reducerPath]: parentApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
})

export default configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware({}).concat(authApi.middleware, parentApi.middleware, thunk),
})
